import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";
import { SectorEnum } from "../../../shared/utils/enum/enum";
import { CriarFuncionarioFormData } from "../schema/criar-funcionario.schema";
import { EditarFuncionarioFormData } from "../schema/editar-funcionario.schema";

const criar = async (data: CriarFuncionarioFormData): Promise<void> => {
    try {
        await baseApiService.post('/employees', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/employees/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/employees/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const configuracoes = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/employees/config/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarFuncionarioFormData): Promise<void> => {
    try {
        await baseApiService.put(`/employees/${id}`, data);
    }
    catch (err) {
        console.error("Erro ao editar funcionário:", err);
        throw errosHandler(err);
    }
};

const findAll = async (
    query?: string,
    pagina = 0,
    limite = 10
): Promise<any> => {
    try {
        const page = pagina + 1;
        
        const url = query
            ? `/employees?page=${page}&limit=${limite}&${query}`
            : `/employees?page=${page}&limit=${limite}`;

        const response = await baseApiService.get(url);
        return response.data.data;

    } catch (error) {
        throw errosHandler(error);
    }
};

const selectEmpresa = async (): Promise<any> => {
    try {
        const response = await baseApiService.get(`/company/select`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};


const select = async (): Promise<any> => {
    try {
        const response = await baseApiService.get('/employees/select');
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};



export const funcionarioService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    selectEmpresa,
    select,
    configuracoes
};

